import React from 'react'

function Map() {
    return (
        <>
            <div className="map_block row_am" data-aos="fade-in" data-aos-duration={1500}>
                <div className="container">
                    <iframe src="https://redirect.lumo.ro/lumo-address-embedded" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
        </>
    )
}

export default Map